import React from "react";
import Reveal from "./Reveal";
import { Check, ArrowRight } from "lucide-react";
import { CHECKOUT_RADIOGRAFIA_49 } from "@/lib/content";

const INCLUDES = [
  "Diagnóstico de situación actual.",
  "Principales fugas de tiempo, ventas y margen.",
  "Prioridad nº1 de mejora.",
  "Experimento recomendado para 7-30 días.",
  "Primer mapa de automatización si procede.",
];

const Price = () => {
  const isExternalCheckout = CHECKOUT_RADIOGRAFIA_49.startsWith("http");

  return (
    <section
      id="precio"
      data-testid="price-section"
      className="et-section relative"
      style={{
        background:
          "linear-gradient(180deg, transparent 0%, rgba(19,40,61,0.3) 50%, transparent 100%)",
      }}
    >
      <div className="et-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          {/* Left Side: Title & Description */}
          <div className="lg:col-span-5">
            <Reveal>
              <div className="et-eyebrow">Precio transparente</div>
            </Reveal>

            <Reveal delay={0.08}>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-white et-text-balance">
                Una Radiografía clara{" "}
                <span className="et-text-gold">por 49 €.</span>
              </h2>
            </Reveal>

            <Reveal delay={0.16}>
              <h3 className="mt-6 text-lg md:text-xl text-[#f5f2ea] font-medium leading-snug">
                No necesitas más herramientas. Necesitas saber qué tocar primero.
              </h3>
            </Reveal>

            <Reveal delay={0.24}>
              <p className="mt-4 text-base md:text-lg text-[#f5f2ea]/80 leading-relaxed">
                Por 49 € recibes una Radiografía de Negocio para detectar dónde estás perdiendo tiempo, ventas o margen, y qué experimento merece la pena probar antes de automatizar nada.
              </p>
            </Reveal>
            
            <Reveal delay={0.32}>
              <p className="mt-8 text-sm text-[#f5f2ea]/60 italic leading-relaxed">
                Después de recibir tu informe, si quieres, podrás reservar una revisión estratégica individual conmigo para aterrizar prioridades y decidir el siguiente experimento.
              </p>
            </Reveal>
          </div>

          {/* Right Side: Pricing Card */}
          <Reveal delay={0.2} className="lg:col-span-7">
            <div
              className="et-card !p-8 md:!p-10 relative overflow-hidden"
              style={{
                background:
                  "linear-gradient(180deg, rgba(19,40,61,0.9) 0%, rgba(16,32,46,0.85) 100%)",
                border: "1px solid rgba(197,160,89,0.25)",
                boxShadow: "0 10px 40px -10px rgba(0,0,0,0.5)",
              }}
            >
              {/* Decorative light effect inside the card */}
              <div
                aria-hidden
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "radial-gradient(circle at 100% 0%, rgba(197,160,89,0.15), transparent 60%)",
                }}
              />

              <div className="relative z-10">
                <div className="flex justify-between items-start border-b border-[#c5a059]/15 pb-6 mb-6">
                  <div>
                    <h4 className="text-xl font-bold text-white tracking-tight">
                      Radiografía de Negocio
                    </h4>
                    <p className="text-xs uppercase tracking-[0.15em] text-[#c5a059] mt-1">
                      Pago único
                    </p>
                  </div>
                  <div className="text-right">
                    <span className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
                      49 €
                    </span>
                    <span className="text-[#f5f2ea]/50 text-xs block mt-1">
                      IVA incl.
                    </span>
                  </div>
                </div>

                <ul className="space-y-4 mb-8">
                  {INCLUDES.map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span
                        className="shrink-0 w-6 h-6 rounded-full grid place-items-center mt-0.5"
                        style={{
                          background: "rgba(197,160,89,0.1)",
                          border: "1px solid rgba(197,160,89,0.3)",
                        }}
                      >
                        <Check className="w-3.5 h-3.5 text-[#c5a059]" />
                      </span>
                      <span className="text-sm md:text-base text-[#f5f2ea]/90 leading-relaxed">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>

                <a
                  href={CHECKOUT_RADIOGRAFIA_49}
                  target={isExternalCheckout ? "_top" : undefined}
                  className="et-btn-primary w-full !py-4 !text-base font-semibold shadow-xl flex justify-center items-center gap-2"
                >
                  Hacer mi Radiografía por 49 €
                  <ArrowRight className="w-5 h-5" />
                </a>

                <p className="mt-5 text-xs text-[#f5f2ea]/50 text-center leading-relaxed">
                  <strong>Nota:</strong> No incluye implementación ni automatizaciones completas. Primero claridad. Luego sistema. Después, si toca, IA.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Price;
